import React from 'react'
import { Helmet } from 'react-helmet';

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | GeoID</title>
      </Helmet>
      <div className='main-container'>
        <div className="section-heading">
          <h1>Terms & Conditions</h1>
        </div>
        <div className="section">
          <p className="para-content">Though all efforts have been made to ensure the accuracy of the content on this portal, Users are advised to verify/check any information with the relevant Government department(s) and/or other source(s), and to obtain any appropriate professional advice before acting on the information provided in this portal.



          </p>
          <p className="para-content">
            The work described in this portal is part of an exploratory research effort at Indian Institute of Technology Gandhinagar, and does not represent the official product of any Institute, or central, state, or local agency.
          </p>
          <p className="para-content">
            The authorized use of data from this site is limited to academic and educational purposes only, and not for operational or commercial purposes. This data is provided "as is" and in no event shall the providers be liable for any damages, including, without limitation, damages resulting from lost data or lost profits or revenue, the costs of recovering such data, the costs of substitute data, claims by third parties or for other similar costs, or any special, incidental, or consequential damages, arising out of the use of the data.
          </p>

          <p className="para-content">
            Copyright Policy: Material featured on this portal may be reproduced free of charge after taking proper permission by sending a mail to us. However, the material has to be reproduced accurately and not to be used in a derogatory manner or in a misleading context. Wherever the material is being published or issued to others, the source must be prominently acknowledged. However, the permission to reproduce this material shall not extend to any material which is identified as being copyright of a third party. Authorisation to reproduce such material must be obtained from the departments/copyright holders concerned.
          </p>

        </div>
      </div>
    </>
  )
}

export default TermsOfUse
